import React from 'react'
import ListaClientes from '../components/ListaClientes'

const clientes = () => {
  return (
    <ListaClientes />
  )
}

export default clientes